import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-confirm-schedule',
  templateUrl: './confirm-schedule.component.html',
  styleUrls: ['./confirm-schedule.component.css']
})
export class ConfirmScheduleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/create-schedule-popup/confirm-schedule/confirm-schedule.component.ts